import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';

/* Local store */
import { localStoreFN } from '../../store/localStorage';
import { VersionPackage } from '../common/versionPackage';

/**
 * component in charge of drawing the side menu
 */
class NavComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      permits: [],
      views: [],
      objSetting: {}
    };
  };

  /**
   * component lifecycle method that is called before it is rendered
   */
  componentDidMount() {
  }

  /**
   * component lifecycle method that is called whenever properties or states change
   * @param {Object} prevProps object with properties before component update
   */
  componentDidUpdate(prevProps) {
    if (prevProps.setting === null && this.props.setting) {
      let permits = [];
      let views = [];
      let objSetting = {};
  
      if (localStoreFN().getItem('permits')) {
        permits = localStoreFN().getItem('permits');
      }

      objSetting = JSON.parse(this.props.setting.value);
      if (objSetting) {
        if (objSetting.generalSetting) {
          views = objSetting.generalSetting.views ? objSetting.generalSetting.views : [];
        }
      }

      this.setState({ 
        permits,
        views,
        objSetting
      }); 
    } 
  }

  render() {
    if (this.props.setting === false && this.props.status === 200) {
      return (
        <nav>
          <div className="nav_version">
            {
              this.props.showVersion && (
                <VersionPackage  />
              )
            }
          </div>

          <div className="collapse_button" onClick={this.props.handleChangeMenuState}>
            <div className="small_tooltip"><p>{ this.props.menuCollapse ? this.props.language.actions.expand : this.props.language.actions.collapse }</p></div>
          </div>
          <div className="nav_inner">
            <div className="nav_box">
              <div>
                <h3>
                  <a id="menu-6" data-type="menu" onClick={this.props.handleNav}>
                    <span className="icon-box icon-account" />
                    <span className="text-box">Configuración Inicial</span>
                  </a>
                </h3>
              </div>
              <div>
                <ul id="submenu-6" data-ok="oksub">
                  {//this.state.permits.includes("wizard") &&
                  true && (
                    <li>
                      <Link
                        to="/dashboard/account_setting"
                        data-route="account_setting"
                        id="menu-6-sub-7"
                        data-menusub="menu-6"
                        onClick={this.props.handleNav}
                      >
                        Ingresa setting
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </nav>
      );
    } else {
      return (
        <nav id={"main_navegation"}>
          <div className="nav_version">
            {
              this.props.showVersion && (
                <VersionPackage  />
              )
            }
          </div>

          <div className="collapse_button" onClick={this.props.handleChangeMenuState}>
            <div className="small_tooltip"><p>{ this.props.menuCollapse ? this.props.language.actions.expand : this.props.language.actions.collapse }</p></div>
          </div>        
          <div className="nav_inner">
            {this.state.permits.includes('fatigue') && this.state.views.includes('fatigue') && (
              <div className="nav_box arrow">
                <div>
                  <h3>
                    <a id="menu-1" data-type="menu" onClick={this.props.handleNav}>
                      <span className="icon-box icon-fatiga" />
                      <span className="text-box">
                        {this.props.language ? this.props.language.menu.biocompatibility : ''}
                      </span>
                    </a>
                  </h3>
                </div>
                <div>
                  <ul id="submenu-1" data-ok="oksub">
                    <li>
                      <Link
                        to="/dashboard/summary_fatigue"
                        data-route="summary_fatigue"
                        id="menu-1-sub-1"
                        data-menusub="menu-1"
                        onClick={this.props.handleNav}
                      >
                        {this.props.language ? this.props.language.subMenu.summary : ''}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/dashboard/detail_fatigue"
                        data-route="detail_fatigue"
                        id="menu-1-sub-2"
                        data-menusub="menu-1"
                        onClick={this.props.handleNav}
                      >
                        {this.props.language ? this.props.language.subMenu.detail : ''}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/dashboard/driver_fatigue"
                        data-route="driver_fatigue"
                        id="menu-1-sub-3"
                        data-menusub="menu-1"
                        onClick={this.props.handleNav}
                      >
                        {this.props.language ? this.props.language.subMenu.driver : ''}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            )}
            {this.state.permits.includes('roadwarning') && this.state.views.includes('roadwarning') && (
              <div className="nav_box arrow">
                <div>
                  <h3>
                    <a id="menu-2" data-type="menu" onClick={this.props.handleNav}>
                      <span className="icon-box icon-microsueno" />
                      <span className="text-box">
                        {this.props.language ? this.props.language.menu.truckSleeps : ''}
                      </span>
                    </a>
                  </h3>
                </div>
                <div>
                  <ul id="submenu-2" data-ok="oksub">
                    <li>
                      <Link
                        to="/dashboard/summary_roadwarning"
                        data-route="summary_roadwarning"
                        id="menu-2-sub-1"
                        data-menusub="menu-2"
                        onClick={this.props.handleNav}
                      >
                        {this.props.language ? this.props.language.subMenu.summary : ''}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/dashboard/detail_roadwarning"
                        data-route="detail_roadwarning"
                        id="menu-2-sub-2"
                        data-menusub="menu-2"
                        onClick={this.props.handleNav}
                      >
                        {this.props.language ? this.props.language.subMenu.detail : ''}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/dashboard/driver_roadwarning"
                        data-route="driver_roadwarning"
                        id="menu-2-sub-3"
                        data-menusub="menu-2"
                        onClick={this.props.handleNav}
                      >
                        {this.props.language ? this.props.language.subMenu.driver : ''}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            )}
            {this.state.permits.includes('behaviour') && this.state.views.includes('behaviour') && (
              <div className="nav_box arrow">
                <div>
                  <h3>
                    <a id="menu-3" data-type="menu" onClick={this.props.handleNav}>
                      <span className="icon-box icon-conductual" />
                      <span className="text-box">
                        {this.props.language ? this.props.language.menu.conduct : ''}
                      </span>
                    </a>
                  </h3>
                </div>
                <div>
                  <ul id="submenu-3" data-ok="oksub">
                    <li>
                      <Link
                        to="/dashboard/summary_behaviour"
                        data-route="summary_behaviour"
                        id="menu-3-sub-1"
                        data-menusub="menu-3"
                        onClick={this.props.handleNav}
                      >
                        {this.props.language ? this.props.language.subMenu.summary : ''}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/dashboard/detail_behaviour"
                        data-route="detail_behaviour"
                        id="menu-3-sub-2"
                        data-menusub="menu-3"
                        onClick={this.props.handleNav}
                      >
                        {this.props.language ? this.props.language.subMenu.detail : ''}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/dashboard/driver_behavior"
                        data-route="driver_behavior"
                        id="menu-3-sub-3"
                        data-menusub="menu-3"
                        onClick={this.props.handleNav}
                      >
                        {this.props.language ? this.props.language.subMenu.driver : ''}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            )}
            {this.state.permits.includes('gauss') && this.state.views.includes('fulfillment') && (
              <div className="nav_box arrow">
                <div>
                  <h3>
                    <a id="menu-7" data-type="menu" onClick={this.props.handleNav}>
                      <span className="icon-box icon-cumplimiento" />
                      <span className="text-box">
                        {this.props.language ? this.props.language.menu.compliance : ''}
                      </span>
                    </a>
                  </h3>
                </div>
                <div>
                  <ul id="submenu-7" data-ok="oksub">
                    <li>
                      <Link
                        to="/dashboard/summary_fulfillment"
                        data-route="summary_fulfillment"
                        id="menu-7-sub-1"
                        data-menusub="menu-7"
                        onClick={this.props.handleNav}
                      >
                        {'test'}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/dashboard/detail_fulfillment"
                        data-route="detail_fulfillment"
                        id="menu-7-sub-2"
                        data-menusub="menu-7"
                        onClick={this.props.handleNav}
                      >
                        {this.props.language ? this.props.language.subMenu.detail : ''}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/dashboard/driver_fulfillment"
                        data-route="driver_fulfillment"
                        id="menu-7-sub-3"
                        data-menusub="menu-7"
                        onClick={this.props.handleNav}
                      >
                        {this.props.language ? this.props.language.subMenu.driver : ''}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            )}
            {this.state.permits.includes('form') && this.state.views.includes('form') && (
              <div className="nav_box arrow">
                <div>
                  <h3>
                    <a id="menu-10" data-type="menu" onClick={this.props.handleNav}>
                      <span className="icon-box icon-tiempo" />
                      <span className="text-box">
                        {this.props.language ? this.props.language.menu.fleet : ''}
                      </span>
                    </a>
                  </h3>
                </div>
                <div>
                  <ul id="submenu-10" data-ok="oksub">
                    <li>
                      <Link
                        to="/dashboard/summary_truck"
                        data-route="summary_truck"
                        id="menu-10-sub-1"
                        data-menusub="menu-10"
                        onClick={this.props.handleNav}
                      >
                        {this.props.language ? this.props.language.subMenu.summary : ''}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            )}
            {this.state.permits.includes('form') && this.state.views.includes('form') && (
              <div className="nav_box arrow">
                <div>
                  <h3>
                    <a id="menu-11" data-type="menu" onClick={this.props.handleNav}>
                      <span className="icon-box icon-inspecciones" />
                      <span className="text-box">
                        {this.props.language ? this.props.language.menu.inspections : ''}
                      </span>
                    </a>
                  </h3>
                </div>
                <div>
                  <ul id="submenu-11" data-ok="oksub">
                    <li>
                      <Link
                        to="/dashboard/summary_inspections"
                        data-route="summary_inspections"
                        id="menu-11-sub-1"
                        data-menusub="menu-11"
                        onClick={this.props.handleNav}
                      >
                        {this.props.language ? this.props.language.subMenu.summary : ''}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            )}
            {this.state.permits.includes('nfa') && this.state.views.includes('nfa') && (
              <div className="nav_box arrow">
                <div>
                  <h3>
                    <a id="menu-12" data-type="menu" onClick={this.props.handleNav}>
                      <span className="icon-box icon-nfa" />
                      <span className="text-box">Nivel de fatiga</span>
                    </a>
                  </h3>
                </div>
                <div>
                  <ul id="submenu-12" data-ok="oksub">
                    <li>
                      <Link
                        to="/dashboard/summary_nfa"
                        data-route="summary_nfa"
                        id="menu-12-sub-1"
                        data-menusub="menu-12"
                        onClick={this.props.handleNav}
                      >
                        Resumen
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/dashboard/detail_nfa"
                        data-route="detail_nfa"
                        id="menu-12-sub-2"
                        data-menusub="menu-12"
                        onClick={this.props.handleNav}
                      >
                        Detalle
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/dashboard/driver_nfa"
                        data-route="driver_nfa"
                        id="menu-12-sub-3"
                        data-menusub="menu-12"
                        onClick={this.props.handleNav}
                      >
                        Conductor
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            )}
            {((this.state.permits.includes('ffdsleep') && this.state.views.includes('ffdsleep')) ||
              (this.state.permits.includes('ffdpvt') && this.state.views.includes('ffdpvt'))) && (
              <div className="nav_box arrow">
                <div>
                  <h3>
                    <a id="menu-100" data-type="menu" onClick={this.props.handleNav}>
                      <span className="icon-box fal fa-thumbs-up" />
                      {
                        (
                          (this.state.views.includes('ffdpvt') && this.state.permits.includes('ffdpvt')) &&
                          (this.state.views.includes('ffdsleep') && this.state.permits.includes('ffdsleep'))) && (
                          <span className="text-box">{this.props.language ? `${this.props.language.menu.ffdPvt} / ${this.props.language.menu.ffdSleep}` : ''}</span>
                        )
                      }
                      {
                        (
                          (this.state.views.includes('ffdpvt') && this.state.permits.includes('ffdpvt')) &&
                          (!this.state.views.includes('ffdsleep') || !this.state.permits.includes('ffdsleep'))) && (
                          <span className="text-box">{this.props.language ? this.props.language.menu.ffdPvt : ''}</span>
                        )
                      }
                      {
                        (
                          (this.state.views.includes('ffdsleep') && this.state.permits.includes('ffdsleep')) &&
                          (!this.state.views.includes('ffdpvt') || !this.state.permits.includes('ffdpvt'))) && (
                          <span className="text-box">{this.props.language ? this.props.language.menu.ffdSleep : ''}</span>
                        )
                      }
                    </a>
                  </h3>
                </div>
                {(this.state.permits.includes('ffdsleep') && this.state.views.includes('ffdsleep')) ? (
                  <div>
                    <ul id="submenu-100" data-ok="oksub">
                      <li>
                        <Link
                          to="/dashboard/summary_ffd_sleep"
                          data-route="summary_ffd_sleep"
                          data-routeaux="summary_ffd_pvt"
                          id="menu-100-sub-1"
                          data-menusub="menu-100"
                          onClick={this.props.handleNav}
                        >
                          {this.props.language ? this.props.language.subMenu.summary : ''}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/dashboard/last_data_ffd_sleep"
                          data-route="last_data_ffd_sleep"
                          data-routeaux="last_data_ffd_pvt"
                          id="menu-100-sub-2"
                          data-menusub="menu-100"
                          onClick={this.props.handleNav}
                        >
                          {this.props.language ? this.props.language.subMenu.results : ''}
                        </Link>
                      </li>
                    </ul>
                  </div>
                ) : (
                  <div>
                    <ul id="submenu-100" data-ok="oksub">
                      <li>
                        <Link
                          to="/dashboard/summary_ffd_pvt"
                          data-route="summary_ffd_pvt"
                          id="menu-100-sub-1"
                          data-menusub="menu-100"
                          onClick={this.props.handleNav}
                        >
                          {this.props.language ? this.props.language.subMenu.summary : ''}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/dashboard/last_data_ffd_pvt"
                          data-route="last_data_ffd_pvt"
                          id="menu-100-sub-2"
                          data-menusub="menu-100"
                          onClick={this.props.handleNav}
                        >
                          {this.props.language ? this.props.language.subMenu.results : ''}
                        </Link>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            )}
            {false && this.state.permits.includes('fatigue') &&
              this.state.views.includes('fatigue') &&
              this.state.permits.includes('behaviour') &&
              this.state.views.includes('behaviour') && (
                <div className="nav_box">
                  <div>
                    <h3>
                      <Link
                        to="/dashboard/driver_record"
                        className="unique"
                        data-type="unique"
                        data-route="driver_record"
                        id="menu-9"
                        onClick={this.props.handleNav}
                      >
                        <span className="icon-box icon-gestionador" />
                        <span className="text-box">
                          {this.props.language ? this.props.language.menu.sheetOfLife : ''}
                        </span>
                      </Link>
                    </h3>
                  </div>
                </div>
              )}
            {this.state.permits.includes('waitingtimes') && this.state.views.includes('waitingtimes') && (
              <div className="nav_box arrow">
                <div>
                  <h3>
                    <a id="menu-8" data-type="menu" onClick={this.props.handleNav}>
                      <span className="icon-box icon-tiempo" />
                      <span className="text-box">
                        {this.props.language ? this.props.language.menu.waitingTime : ''}
                      </span>
                    </a>
                  </h3>
                </div>
                <div>
                  <ul id="submenu-8" data-ok="oksub">
                    <li>
                      <Link
                        to="/dashboard/detail_waiting_times"
                        data-route="detail_waiting_times"
                        id="menu-8-sub-1"
                        data-menusub="menu-8"
                        onClick={this.props.handleNav}
                      >
                        {this.props.language ? this.props.language.subMenu.detail : ''}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            )}
            {this.state.permits.includes('assignment') && this.state.views.includes('assignment') && (
              <div className="nav_box arrow">
                <div>
                  <h3>
                    <a id="menu-4" data-type="menu" onClick={this.props.handleNav}>
                      <span className="icon-box icon-asignador" />
                      <span className="text-box">
                        {this.props.language ? this.props.language.menu.assignment : ''}
                      </span>
                    </a>
                  </h3>
                </div>
                <div>
                  <ul id="submenu-4" data-ok="oksub">
                    <li>
                      <Link
                        to="/dashboard/assignment_list"
                        data-route="assignment_list"
                        id="menu-4-sub-1"
                        data-menusub="menu-4"
                        onClick={this.props.handleNav}
                      >
                        {this.props.language ? this.props.language.subMenu.listOfVehicule : ''}
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/dashboard/allocator"
                        data-route="assignment_list"
                        id="menu-4-sub-2"
                        data-menusub="menu-4"
                        onClick={this.props.handleNav}
                      >
                        {/*this.props.language ? this.props.language.subMenu.listOfVehicule : ''*/}
                        Asignador
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            )}
            {(this.state.permits.includes('task') || this.state.permits.includes('taskread')) && this.state.views.includes('task') && (
              <div className="nav_box">
                <div>
                  <h3>
                    <Link
                      to="/dashboard/tasks_manager"
                      className="unique task_manager_menu"
                      data-type="unique"
                      data-route="tasks_manager"
                      id="menu-5"
                      onClick={this.props.handleNav}
                    >
                      <span className="icon-box icon-gestionador" />
                      <span className="text-box">
                        {this.props.language ? this.props.language.menu.manager : ''}
                      </span>
                    </Link>
                  </h3>
                </div>
              </div>
            )}
            {(this.state.views.includes('flowrequests') && 
              this.state.permits.includes('flowrequestsadmin')) && (
              <div className="nav_box">
                <div>
                  <h3>
                    <Link
                      to="/dashboard/flow_admin_rca_reports"
                      className="unique"
                      data-type="unique"
                      data-route="flow_admin_rca_reports"
                      id="menu-21"
                      onClick={this.props.handleNav}
                    >
                      <span className="icon-box icon-gestionador" />
                      <span className="text-box">
                        {"Reportes RCA"}
                      </span>
                    </Link>
                  </h3>
                </div>
              </div>
            )}
            {(this.state.views.includes('flowrequests') && 
              (this.state.permits.includes('flowrequestsadmin') 
              || this.state.permits.includes('flowrequestsapplicant'))) && (
              <div className="nav_box arrow">
                <div>
                  <h3>
                    <a id="menu-20" data-type="menu" onClick={this.props.handleNav}>
                      <span className="icon-box icon-inspecciones" />
                      <span className="text-box">Gestión de flujos</span>
                    </a>
                  </h3>
                </div>
                <div>
                  <ul id="submenu-20" data-ok="oksub">
                    {this.state.permits.includes('flowrequestsadmin') && (
                      <li>
                        <Link
                          to="/dashboard/flow_admin_detail"
                          data-route="flow_admin_detail"
                          id="menu-20-sub-1"
                          data-menusub="menu-20"
                          onClick={this.props.handleNav}
                        >
                          Solicitudes de flujos
                        </Link>
                      </li>
                    )}
                    {this.state.permits.includes('flowrequestsapplicant') && (
                      <li>
                        <Link
                          to="/dashboard/flow_applicant_detail"
                          data-route="flow_applicant_detail"
                          id="menu-20-sub-2"
                          data-menusub="menu-20"
                          onClick={this.props.handleNav}
                        >
                          Solicitudes de flujos
                        </Link>
                      </li>
                    )}
                    {(this.state.permits.includes('flowrequestsadmin') ||
                      this.state.permits.includes('flowrequestsapplicant')) && (
                      <li>
                        <Link
                          to="/dashboard/flows_history"
                          data-route="flows_history"
                          id="menu-20-sub-3"
                          data-menusub="menu-20"
                          onClick={this.props.handleNav}
                        >
                          Historial
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            )}
            {this.state.permits.includes('reports') && this.state.views.includes('reports') && (
              <div className="nav_box">
                <div>
                  <h3>
                    <Link
                      to="/dashboard/reports"
                      className="unique"
                      data-type="unique"
                      data-route="reports"
                      id="menu-30"
                      onClick={this.props.handleNav}
                    >
                      <span className="icon-box icon-reporte" />
                      <span className="text-box">
                        {this.props.language ? this.props.language.menu.reports : ''}
                      </span>
                    </Link>
                  </h3>
                </div>
              </div>
            )}
            {this.state.views.includes('account') && this.state.permits.includes('accountview') && (
              <div className="nav_box arrow">
                <div>
                  <h3>
                    <a id="menu-6" data-type="menu" onClick={this.props.handleNav}>
                      <span className="icon-box icon-account" />
                      <span className="text-box">
                        {' '}
                        {this.props.language ? this.props.language.menu.dataManagement : ''}
                      </span>
                    </a>
                  </h3>
                </div>
                <div>
                  <ul id="submenu-6" data-ok="oksub">
                    {this.state.views.includes('account_list') && this.state.permits.includes('dynamiclist') && (
                      <li>
                        <Link
                          to="/dashboard/account_list"
                          data-route="account_list"
                          id="menu-6-sub-1-0"
                          data-menusub="menu-6"
                          onClick={this.props.handleNav}
                        >
                          {this.props.language ? this.props.language.subMenu.dynamicList : ''}
                        </Link>
                      </li>
                    )}
                    {this.state.permits.includes('drivers') && (
                      <li>
                        <Link
                          to="/dashboard/account_driver"
                          data-route="account_driver"
                          id="menu-6-sub-1-1"
                          data-menusub="menu-6"
                          onClick={this.props.handleNav}
                        >
                          {this.props.language ? this.props.language.subMenu.drivers : ''}
                        </Link>
                      </li>
                    )}
                    {this.state.permits.includes('drivers') && this.state.permits.includes('driverscrud') && (
                      <li>
                        <Link
                          to="/dashboard/homologation_driver"
                          data-route="homologation_driver"
                          id="menu-6-sub-2"
                          data-menusub="menu-6"
                          onClick={this.props.handleNav}
                        >
                          {this.props.language ? this.props.language.subMenu.pendingAssociationDrivers : ''}
                        </Link>
                      </li>
                    )}
                    {this.state.permits.includes('vehicles') && (
                      <li>
                        <Link
                          to="/dashboard/account_vehicle"
                          data-route="account_vehicle"
                          id="menu-6-sub-3"
                          data-menusub="menu-6"
                          onClick={this.props.handleNav}
                        >
                          {this.props.language ? this.props.language.subMenu.team : ''}
                        </Link>
                      </li>
                    )}
                    {this.state.permits.includes('vehicles') && this.state.permits.includes('vehiclescrud') && (
                      <li>
                        <Link
                          to="/dashboard/homologation_vehicle"
                          data-route="homologation_vehicle"
                          id="menu-6-sub-4"
                          data-menusub="menu-6"
                          onClick={this.props.handleNav}
                        >
                          {this.props.language ? this.props.language.subMenu.pendingAssociationTeam : ''}
                        </Link>
                      </li>
                    )}
                    {this.state.views.includes('account_semi_trailer') && this.state.permits.includes('vehicles') && (
                      <li>
                        <Link
                          to="/dashboard/account_semi_trailer"
                          data-route="account_semi_trailer"
                          id="menu-6-sub-4-0"
                          data-menusub="menu-6"
                          onClick={this.props.handleNav}
                        >
                          {this.props.language ? this.props.language.subMenu.semiTrailer : ''}
                        </Link>
                      </li>
                    )}
                    {this.state.views.includes('account_semi_trailer') && this.state.permits.includes('vehicles') && this.state.permits.includes('vehiclescrud') && (
                      <li>
                        <Link
                          to="/dashboard/homologation_semi_trailer"
                          data-route="homologation_semi_trailer"
                          id="menu-6-sub-4-1"
                          data-menusub="menu-6"
                          onClick={this.props.handleNav}
                        >
                          {this.props.language ? this.props.language.subMenu.pendingAssociationSemiTrailer : ''}
                        </Link>
                      </li>
                    )}
                    {((this.state.permits.includes('ffdsleep') && this.state.views.includes('ffdsleep')) ||
                      (this.state.permits.includes('ffdpvt') && this.state.views.includes('ffdpvt'))) && (
                      <li>
                        <Link
                          to="/dashboard/account_working_shift_group"
                          data-route="account_working_shift_group"
                          id="menu-6-sub-9-0"
                          data-menusub="menu-6"
                          onClick={this.props.handleNav}
                        >
                          {this.props.language ? this.props.language.subMenu.workingShiftGroup : ''}
                        </Link>
                      </li>
                    )}
                    {this.state.permits.includes('geozones') && (
                      <li>
                        <Link
                          to="/dashboard/account_geozone"
                          data-route="account_geozone"
                          id="menu-6-sub-5"
                          data-menusub="menu-6"
                          onClick={this.props.handleNav}
                        >
                          {this.props.language ? this.props.language.subMenu.geozone : ''}
                        </Link>
                      </li>
                    )}
                    {this.state.permits.includes('tags') && (
                      <li>
                        <Link
                          to="/dashboard/account_tag"
                          data-route="account_tag"
                          id="menu-6-sub-8"
                          data-menusub="menu-6"
                          onClick={this.props.handleNav}
                        >
                          {this.props.language ? this.props.language.subMenu.tag : ''}
                        </Link>
                      </li>
                    )}
                    {this.state.permits.includes('wizard') && (
                      <li>
                        <Link
                          to="/dashboard/account_setting"
                          data-route="account_setting"
                          id="menu-6-sub-7"
                          data-menusub="menu-6"
                          onClick={this.props.handleNav}
                        >
                          {this.props.language ? this.props.language.subMenu.configuration : ''}
                        </Link>
                      </li>
                    )}
                    {this.state.permits.includes('user') && (
                      <li>
                        <Link
                          to="/dashboard/account_user"
                          data-route="account_driver"
                          id="menu-6-sub-6"
                          data-menusub="menu-6"
                          onClick={this.props.handleNav}
                        >
                          {this.props.language ? this.props.language.subMenu.users : ''}
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            )}
          </div>
  
          {
            (this.state.showUrlError) && (
              <SweetAlert
                error
                closeOnClickOutside={true}
                confirmBtnCssClass="confirm-button"
                title={
                  <span className="modal-title">
                    <strong>
                      {this.state.msgUrlErrorTitle}
                    </strong>
                  </span>
                }
                onConfirm={() => this.handleShowUrlError(false, '', '')}
              >
                <div className="tilte-modal-box" dangerouslySetInnerHTML={{__html: this.state.msgUrlError}} />
              </SweetAlert>
            )
          }
        </nav>
      );
    }
  }
};

export default NavComponent;



// WEBPACK FOOTER //
// ./source/client/components/nav/index.jsx